var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import 'pixi-spine';
import { AnimationLoader } from './animation-loader';
import { BitmapFontLoader } from './bitmap-font-loader';
import { DataLoader } from './data-loader';
import { FontLoader } from './font-loader';
import { SoundLoader } from './sound-loader';
import { SpritesheetLoader } from './spritesheet-loader';
import { TextureLoader } from './texture-loader';
var AssetManager = (function () {
    function AssetManager() {
    }
    AssetManager.load = function (config) {
        var _this = this;
        if (!this.loader) {
            this.loader = new PIXI.loaders.Loader();
        }
        this.loader.baseUrl = config.baseUrl;
        if (config.skin !== '') {
            this.loader.baseUrl += config.skin + "/";
        }
        if (config.version !== '') {
            this.loader.baseUrl += config.version + "/";
        }
        return TextureLoader.loadTextures(config.assetList.textures, this.loader)
            .then(function () { return config.assetList.data && DataLoader.loadData(config.assetList.data, _this.loader); })
            .then(function () { return config.assetList.spriteSheets && SpritesheetLoader.loadSpritesheets(config.assetList.spriteSheets, _this.loader); })
            .then(function () { return config.assetList.animations && AnimationLoader.loadAnimations(config.assetList.animations, _this.loader); })
            .then(function () { return _this.cacheAnimationData(_this.loader.resources); })
            .then(function () { return config.assetList.sounds && SoundLoader.loadSounds(config.assetList.sounds, _this.loader); })
            .then(function () { return config.assetList.fonts && FontLoader.loadFonts(config.assetList.fonts, config.fontUrl ? config.fontUrl : _this.loader.baseUrl); })
            .then(function () { return config.assetList.bitmapFonts && BitmapFontLoader.load(config.assetList.bitmapFonts, _this.loader); })
            .then(function () { return Promise.resolve(_this.loader.resources); });
    };
    AssetManager.dispose = function () {
        this.loader.destroy();
        this.loader = new PIXI.loaders.Loader();
        this.animations = null;
    };
    AssetManager.cacheAnimationData = function (resources) {
        this.animations = Object.entries(resources)
            .filter(function (_a) {
            var name = _a[0], resource = _a[1];
            return resource.hasOwnProperty('spineData');
        })
            .map(function (_a) {
            var name = _a[0], resource = _a[1];
            return [name, resource.spineData];
        })
            .reduce(function (obj, _a) {
            var key = _a[0], value = _a[1];
            return (__assign({}, obj, (_b = {}, _b[key] = value, _b)));
            var _b;
        }, {});
        return Promise.resolve();
    };
    return AssetManager;
}());
export { AssetManager };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@arcade-client/asset-manager/dist/esm/index.js
// module id = null
// module chunks = 